const LocaleUtil = {
	getLocale: function (): string {
		return window.lang || "de-DE";
	},
	getAvailableLocales: function (): string[] {
		return window.locales ? window.locales.split(",") : ["de-DE"];
	},
	isLanguageSymbolic: function (locale: string): boolean {
		return locale === "zh-CN" || locale === "ja-JP";
	},
	isSelectedLanguageSymbolic: function (): boolean {
		return this.isLanguageSymbolic(this.getLocale());
	},
};
export default LocaleUtil;
